<template>
  <div class="AppSalesTab">
    <div>
      <div class="flex items-end">
        <div class="input-box box-220">
          <p class="input-label">Quick Reports</p>
          <el-select
          v-model="newquickReports"
            size="medium"
            placeholder="Quick Report"
            @change="commitQuickReports(newquickReports)"
          >
            <el-option
              v-for="(quick_report, index) in allQuickReports"
              :key="index"
              :value="quick_report.id"
              :label="quick_report.name"
              :disabled="
                isContributionView &&
                (quick_report.id == 'day' ||
                  quick_report.id == 'week' ||
                  quick_report.id == 'month' ||
                  quick_report.id == 'wow' ||
                  quick_report.id == 'mom')
              "
              >{{ quick_report.name }}</el-option
            >
          </el-select>
        </div>
        <div class="input-box box-300">
          <!-- <p class="input-label">Location</p> -->
          <base-locations-dropdown class="mdms" @selectedLocationVal="dropDownUpdate" />
        </div>
        <div class="input-box box-220">
          <p class="input-label">From</p>
          <el-date-picker
            v-model="dateFrom"
            size="medium"
            :disabled="isDatesDisabled"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="Select Date"
            :picker-options="datePickerOptions"
          />
        </div>
        <div class="input-box box-220">
          <p class="input-label">To</p>
          <el-date-picker
            v-model="dateTo"
            :disabled="isDatesDisabled"
            size="medium"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="Select Date"
            :picker-options="datePickerOptions"
          />
        </div>
        <label>&nbsp;</label>
        <BaseButton
          type="text"
          style="height: 36px"
          class="orng-btn"
          buttonclass="btn p-2 text-sm font-extrabold"
          @click="onGoClick()"
          >Go</BaseButton
        >
      </div>

      <div class="input-box box-300 mt-4">
        <base-categories-dropdown
          v-if="isCategoryPage"
          class="mdms"
          style="width: 100%"
          @categoryUpdate="categoryDropDownUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AnalyticsServerAddr, serverAddr } from "../../../networkConfig";
import { AppSalesTabNC } from "../../../../mixins/appSalesTabNC";
import { resolve } from "q";
import { EventBus } from "../../../eventBus";
import axios from "axios";
import { mapState, mapActions } from "vuex";
import BaseLocationsDropdown from "../../baseLocationsDD/BaseLocationsDD.vue";
import BaseCategoriesDropdown from "../../baseCategoriesDD/BaseCategoriesDD.vue";
import { CommonMixin } from "../../../../mixins/common.mixin";
import { mapGetters } from "vuex";
import moment from "moment";

const locationBasicsTypes = ["country", "region", "subregion", "outlet"];

export default {
  name: "AppSalesTab",
  components: {
    BaseLocationsDropdown,
    BaseCategoriesDropdown,
  },
  mixins: [AppSalesTabNC, CommonMixin],
  props: [],
  data() {
    return {
      dateFrom: this.yesterdayDate(),
      dateTo: this.yesterdayDate(),
      quickReports: "sale",
      newquickReports: "sale",
      selectCategory: [],
      // selectOrderType: "",
      selectSalesView:
        this.$route.name == "Location" ? "adt" : "contribution_sale",
      selectLocation: "",
      categoryDD: [],
      isCategoryInSales: this.$route.name == "Category" ? true : false,
      isLocationInSales: this.$route.name == "Location" ? true : false,
      // locations: "",
      loc_selected: [],
      cat_selected: [],
      // loc_dropdown: [],
      cat_dropdown: [],
      basics: this.$route.name == "Category" ? "category" : "outlet",
      // cat_basics: "category",
      map: [],
      pageInfo: {
        pageSize: 10,
        currentPage: 1,
      },
      isConsolidated: false,

      isButtonClicked: false,
      previousBasics: "",
      buttonClicked: {},
      whenInCatPageLocBasics: "", // when route is category the basics selected from location dropdown,
      datePickerOptions: {
        disabledDate: this.disabledDueDate,
        firstDayOfWeek: 1,
      },
      basicsInfo: {
        id: "",
        route: this.$route.name,
        basicsFrom: "",
        previousBasics: "",
        currentBasics: this.$route.name == "Category" ? "category" : "outlet",
      },
      locBasicsInCatPage: "",
      allQuickReports: [
        {
          name: "Sale",
          id: "sale",
          isDisabled: false,
        },
        {
          name: "Daily Sales",
          id: "day",
          isDisabled: false,
        },
        {
          name: "Weekly Sales",
          id: "week",
          isDisabled: false,
        },
        {
          name: "Monthly Sales",
          id: "month",
          isDisabled: false,
        },
        {
          name: "Week To Date",
          id: "wtd",
          isDisabled: false,
        },
        {
          name: "Month To Date",
          id: "mtd",
          isDisabled: false,
        },
        {
          name: "Quarter To Date",
          id: "qtd",
          isDisabled: false,
        },
        {
          name: "Year To Date",
          id: "ytd",
        },
        {
          name: "Week On Week",
          id: "wow",
          isDisabled: false,
        },
        {
          name: "Month On Month",
          id: "mom",
          isDisabled: false,
        },
      ],
      allSalesView: [
        {
          name: "Sale",
          id: "amt",
          isVisible:
            this.$route.name == "Category" || this.$route.name == "Location",
        },
        {
          name: "Average Daily Transaction",
          id: "adt",
          isVisible:
            this.$route.name == "Category" || this.$route.name == "Location",
        },
        {
          name: "Average Ticket Size",
          id: "at",
          isVisible:
            this.$route.name == "Category" || this.$route.name == "Location",
        },
        {
          name: "Item Per Transaction",
          id: "ipt",
          isVisible:
            this.$route.name == "Category" || this.$route.name == "Location",
        },
        {
          name: "Contribution Amount",
          id: "contribution_amt",
          isVisible: this.$route.name == "Category" ? true : false,
        },
        {
          name: "Contribution Sale",
          id: "contribution_sale",
          isVisible: this.$route.name == "Category" ? true : false,
        },
        {
          name: "Sale Quantity",
          id: "qty",
          isVisible: this.$route.name == "Category" ? true : false,
        },
        // {
        // 	name: "Contribution Margin",
        // 	id: "contribution_margin",
        // 	isVisible: this.$route.name == "Category" ? true : false
        // }
      ],
      responseMetaField: {},
      stored_breadCrumbs: [],
      temp: [],
    };
  },
  computed: {
    ...mapState("CommonStore", ["tablePageCount", "locations", "categories"]),
    ...mapGetters([
      "getAnalyticsData",
      "getIsOutletClickedFromTable",
      "getSalesView",
    ]),

    isCategoryPage() {
      return this.$route.name == "Category";
    },

    isLocationPage() {
      return this.$route.name == "Location";
    },

    isContributionView() {
      return (
        this.selectSalesView == "contribution_amt" ||
        this.selectSalesView == "contribution_sale" ||
        this.selectSalesView == "contribution_margin"
      );
    },

    isDatesDisabled() {
      return (
        this.newquickReports == "wow" ||
        this.newquickReports == "mom" ||
        this.newquickReports == "wtd" ||
        this.newquickReports == "mtd" ||
        this.newquickReports == "qtd" ||
        this.newquickReports == "ytd"
      );
    },

    filterLocIds() {
      // const locSelected = this.$store.getters.getLocSelected;
      return this.loc_selected.map((obj) => obj.id);
    },

    filterCatIds() {
      return this.cat_selected.map((obj) => obj.id);
    },
  },
  watch: {
    isContributionView: function (val) {
      // disable options in quickreports dropdown upon selection of contribution options in view dropdown
      for (var i = 0; i < this.allQuickReports.length; i++) {
        const qr = this.allQuickReports[i].id;
        if (
          qr == "sale" ||
          qr == "day" ||
          qr == "week" ||
          qr == "month" ||
          qr == "mom" ||
          qr == "wow"
        ) {
          this.$set(
            this.allQuickReports[i],
            "isDisabled",
            (this.allQuickReports[i].isDisabled = val ? true : false)
          );
        }
      }
    },

    getSalesView(newValue, oldValue) {
      if (newValue) {
        this.onSalesViewChange(newValue);
      }
    },
  },
  mounted() {
    EventBus.$on("buttonClickedEvent", this.buttonClickedFn);
    EventBus.$on("sortTable", this.sortTableByHeading);
    EventBus.$on("clickBreadcurmbSalesEvent", this.breadCurmbClickable);
    EventBus.$on("clickToShowInitialSalesData", this.showInitialData);
    EventBus.$on("pageInfoChangeSalesEvent", this.handlePageInfoChange);
    // EventBus.$on("salesViewChanged", this.onSalesViewChange);

    // EventBus.$on("currentPageChangeSalesEvent", this.handleCurrentPageChange);
    this.$store.commit("setselectSalesView", this.selectSalesView);
    this.$store.commit("setLocBasis", this.basics);
    this.$store.commit("setCatBasics", this.cat_basics);
    this.$store.commit("setQuickReports", this.quickReports);

    if (!this.getIsOutletClickedFromTable) {
      // only don't call this function when outlet button is clicked on table row
      this.combineData(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    } else {
      // default set query object when user shift location to catergory ui by clicking store id
      if (localStorage.getItem("setDefaultQueryObject")) {
        var queryObject = JSON.parse(
          localStorage.getItem("setDefaultQueryObject")
        );
        this.quickReports = queryObject.quickreport;
        this.dateFrom = queryObject.start_date;
        this.dateTo = queryObject.end_date;
        this.selectSalesView = queryObject.view;
      }
    }
    localStorage.removeItem("setDefaultQueryObject");
    EventBus.$on("downloadCsvEvent", this.getOptionsSelectedBySales);
    EventBus.$on("breadCrumbs", (data) => {
      console.log("breadCrumbs", data);
      this.stored_breadCrumbs = data;
    });
  },

  beforeDestroy() {
    EventBus.$off("pageInfoChangeSalesEvent", this.handlePageInfoChange);
    EventBus.$off("buttonClickedEvent", this.buttonClickedFn);
    EventBus.$off("clickBreadcurmbSalesEvent", this.breadCurmbClickable);
    EventBus.$off("clickToShowInitialSalesData", this.showInitialData);
    EventBus.$off("downloadCsvEvent", this.getOptionsSelectedBySales);
    EventBus.$off("sortTable", this.sortTableByHeading);
    // EventBus.$off("salesViewChanged", this.onSalesViewChange);
  },

  methods: {
    sortTableByHeading(params) {
      console.log("sortTableByHeading", params);
      this.combineData(
        this.queryObject(this.basicsInfo, false, params),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    onSalesViewChange(view) {
      if (
        (view == "contribution_amt" || view == "contribution_sale") &&
        this.$route.name == "Category"
      ) {
        if (
          this.quickReports == "day" ||
          this.quickReports == "week" ||
          this.quickReports == "month"
        ) {
          this.quickReports = "sale";
        }
      }

      this.quickReports = this.newquickReports;
      this.selectSalesView = view;
      this.$store.commit("setselectSalesView", this.selectSalesView);
      this.commitselectSalesView(view);
    },

    queryObject(result, isConsolidated, sorting_params) {

      // console.log(sorting_params)
      this.quickReports = this.newquickReports;
      this.isConsolidated = isConsolidated;
      this.basics = result.currentBasics;
      return {
        start_date: this.dateFrom,
        end_date: this.dateTo,
        view: this.selectSalesView,
        quickreport: this.quickReports,
        aggregate: this.quickReports,
        basics: 'outlet',
        filters: this.getAllFilters(
          this.$route.name == "Category" ? false : this.isConsolidated,
          result
        ),
        sort_by: sorting_params ? sorting_params.sort_by : "",
        ascending:
          sorting_params != undefined ? sorting_params.ascending : false,
      };
    },

    breadCurmbClickable(selected_bredcrumb, element) {
      if (this.isLocationPage) {
        this.loc_selected = [element[0]];
      }

      if (this.isCategoryPage) {
        this.cat_selected = [element[0]];
      }

      // ******************set queryObject of current clickabled breadcurmb**********************************
      for (var i in this.stored_breadCrumbs) {
        for (var key in this.stored_breadCrumbs[i]) {
          if (key == selected_bredcrumb) {
            // *******************Removed next clickable breadCurmb************************************
            this.stored_breadCrumbs.splice(
              Number(i) + 1,
              this.stored_breadCrumbs.length - 1
            );
          }
        }
      }

      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
      // this.basics = analyticsQueryObject.basics;
      this.basicsInfo = element[1]; // setting this.bascisInfo

      this.combineData(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );

      // if (this.basics === "category" && this.isLocationPage == true) {
      // 	// debugger;
      // 	this.$store.commit("IS_OUTLET_CLIKED_FROM_TABLE", true);
      // 	this.$router.push({ name: "Category" });
      // }
    },

    showInitialData() {
      console.log("clickToShowInitialSalesData");
      // set initial all variable for shown default render table data
      this.basicsInfo = {
        id: "",
        route: this.$route.name,
        basicsFrom: "",
        previousBasics: "",
        currentBasics: this.$route.name == "Category" ? "category" : "outlet",
      };

      if (!this.getIsOutletClickedFromTable) {
        // only don't call this function when outlet button is clicked on table row
        this.combineData(
          this.queryObject(this.basicsInfo, false),
          this.queryObject(this.basicsInfo, true),
          this.pageInfo
        );
      } else {
        // default set query object when user shift location to catergory ui by clicking store id
        if (localStorage.getItem("setDefaultQueryObject")) {
          var queryObject = JSON.parse(
            localStorage.getItem("setDefaultQueryObject")
          );
          this.quickReports = queryObject.quickreport;
          this.dateFrom = queryObject.start_date;
          this.dateTo = queryObject.end_date;
          this.selectSalesView = queryObject.view;
        }
      }

      this.stored_breadCrumbs = []; //clear all breadcurmbs
      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
    },

    dropDownUpdate(update) {
      this.loc_selected = update;
      if (
        this.isCategoryPage &&
        locationBasicsTypes.indexOf(update) > -1
      ) {
        this.locBasicsInCatPage = update;
      } else {
        // this.basicsInfo = this.getBasics(update, update, "dropdown");
      this.basicsInfo.id = update;
			this.basicsInfo.route = this.$route.name;
			this.basicsInfo.basicsFrom = '';
			this.basicsInfo.previousBasics = 'outlet';
			this.basicsInfo.currentBasics = 'outlet';
      }
    },

    categoryDropDownUpdate(categoryDDUpdate) {
      this.cat_selected = categoryDDUpdate.cat_selected;
      this.basicsInfo = this.getBasics(
        categoryDDUpdate.cat_basics,
        categoryDDUpdate.id,
        "dropdown"
      );
    },

    storeBreadcurmb(element) {
      var temp = [];
      temp.push(element);
      temp.push(this.basicsInfo);
      if (this.stored_breadCrumbs.length) {
        if (!this.lookup(element.value, this.stored_breadCrumbs)) {
          this.stored_breadCrumbs.push({
            [element.value]: temp,
          });
        }
      } else {
        this.stored_breadCrumbs.push({
          [element.value]: temp,
        });
      }
      // console.log(this.stored_breadCrumbs);
      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
    },

    buttonClickedFn(element) {
      console.log("element", element);
      if (element.value == "Consolidated" || this.basics == "product") {
        return;
      }

      EventBus.$emit("activeBreadCrumb", element.value);
      if (this.isLocationPage) {
        this.loc_selected = [element];
        this.$store.commit("setLocSelected", [element]);
      }

      if (this.isCategoryPage) {
        this.cat_selected = [element];
      }

      this.basicsInfo = this.getBasics(this.basics, element.id, "table");

      this.resetPageInfo();
      const analyticsQueryObject = this.queryObject(this.basicsInfo, false);
      if (
        this.basics === "category" &&
        (analyticsQueryObject.view == "trans" ||
          analyticsQueryObject.view == "ipt" ||
          analyticsQueryObject.view == "at" ||
          analyticsQueryObject.view == "adt")
      ) {
        analyticsQueryObject.view = "contribution_sale";
      }
      const consolidatedQueryObject = this.queryObject(this.basicsInfo, true);
      if (
        this.basics === "category" &&
        (consolidatedQueryObject.view == "trans" ||
          consolidatedQueryObject.view == "ipt" ||
          consolidatedQueryObject.view == "at" ||
          consolidatedQueryObject.view == "adt")
      ) {
        consolidatedQueryObject.view = "contribution_sale";
        // this.$store.commit("setNameOfGraph", "Contribution Sale");
      }

      // set current query object to show default drop down in sale category ui
      localStorage.setItem(
        "setDefaultQueryObject",
        JSON.stringify(analyticsQueryObject)
      );

      this.combineData(
        analyticsQueryObject,
        consolidatedQueryObject,
        this.pageInfo
      ); //basics is set in this function

      if (this.basics === "category" && this.isLocationPage == true) {
        // debugger;
        this.$store.commit("IS_OUTLET_CLIKED_FROM_TABLE", true);
        this.$router.push({ name: "Category" }).catch(()=>{});
      }
      this.storeBreadcurmb(element);
    },

    onGoClick() {
      this.$store.commit("setDateFrom", this.dateTo);
      this.$store.commit("setDateTo", this.dateFrom);
      this.quickReports = this.newquickReports;
      this.$store.commit("setQuickReports", this.quickReports);
      this.resetPageInfo();
      this.combineData(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    commitQuickReports(payload) {
      if (payload != "day" && payload != "sale") {
        if (
          this.responseMetaField.hasOwnProperty("start_date") &&
          this.responseMetaField.start_date != "" &&
          this.responseMetaField.hasOwnProperty("end_date") &&
          this.responseMetaField.end_date != ""
        ) {
          this.dateTo = this.dateFrom = this.yesterdayDate();
        }
      }
      // this.resetPageInfo();
      // if (!this.basicsInfo.currentBasics) {
      //   this.basicsInfo.currentBasics = this.basics;
      // }
      // this.combineData(
      //   this.queryObject(this.basicsInfo, false),
      //   this.queryObject(this.basicsInfo, true),
      //   this.pageInfo
      // );
    },

    commitSelectCategory(payload) {
      this.$store.commit("setSelectCategory", payload);
      this.resetPageInfo();
      this.combineData(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    commitselectSalesView(payload) {
      this.resetPageInfo();

      if (this.$route.name == "Location") {
        this.basics = "outlet";
      } else {
        this.basics = "category";
      }
      this.basicsInfo.currentBasics = this.basics;
      this.basicsInfo.id = "";
      this.basicsInfo.previousBasics = "";
      console.log(this.basicsInfo);
      this.combineData(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    commitSelectLocation(payload) {
      this.$store.commit("setSelectLocation", payload);
      this.resetPageInfo();
      this.basics = "category";
      this.combineData(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    setDatesBaseOnQuickReport(responseData) {
      if (
        responseData.meta.hasOwnProperty("start_date") &&
        responseData.meta.start_date != "" &&
        responseData.meta.hasOwnProperty("end_date") &&
        responseData.meta.end_date != ""
      ) {
        // if(this.quickReports != 'mom'){
        this.dateFrom = moment(responseData.meta.start_date).format(
          "YYYY-MM-DD"
        );
        this.dateTo = moment(responseData.meta.end_date).format("YYYY-MM-DD");
      }
    },

    AnalyticsData(queryObject, pageInfo) {
      console.log("queryObject", queryObject);
      this.isConsolidated = false;
      const objectWithoutKey = (object, key) => {
        const { [key]: deletedKey, ...otherKeys } = object;
        return otherKeys;
      };
      if (
        this.quickReports == "mtd" ||
        this.quickReports == "ytd" ||
        this.quickReports == "wtd" ||
        this.quickReports == "qtd" ||
        this.quickReports == "sale" ||
        this.quickReports == "wow" ||
        this.quickReports == "mom"
      ) {
        return serverAddr
          .post(
            `/sales/analytics/?page=${pageInfo.currentPage}&page_size=${pageInfo.pageSize}`,
            objectWithoutKey(queryObject, "aggregate")
          )
          .then((tableDataResponse) => {
            if (tableDataResponse.data) {
              const responseData = JSON.parse(tableDataResponse.data);
              this.responseMetaField = responseData.meta;
              this.setDatesBaseOnQuickReport(responseData);
              this.$store.commit(
                "CommonStore/TABLE_PAGE_COUNT",
                responseData.count
              );
              // console.log("responseData", responseData);
              var ids = responseData.results.map((obj) => {
                return Object.keys(obj)[0];
              });
              ids = ids.filter((id) => id != "columns" && id != "");
              // console.log("mapping ids", ids);
            }
            return serverAddr
              .post("/common/name-mapping/", {
                basics: this.basics,
                id_list: ids,
              })
              .then((mapping) => {
                if (mapping.data) {
                  const mappingArray = JSON.parse(mapping.data);
                  return {
                    tableDataResponse: tableDataResponse,
                    mappingArray: mappingArray,
                    tableType: this.quickReports,
                  };
                }
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        return serverAddr
          .post(
            `sales/query/?page=${pageInfo.currentPage}&page_size=${pageInfo.pageSize}`,
            objectWithoutKey(queryObject, "quickreport")
          )
          .then((tableDataResponse) => {
            if (tableDataResponse.data) {
              const responseData = JSON.parse(tableDataResponse.data);
              this.responseMetaField = responseData.meta;
              this.setDatesBaseOnQuickReport(responseData);
              this.$store.commit(
                "CommonStore/TABLE_PAGE_COUNT",
                responseData.count
              );
              var ids = responseData.results.map((obj) => {
                // some response may contain the columns key
                return Object.keys(obj)[0];
              });
              ids = ids.filter((id) => id != "columns");
            }
            return serverAddr
              .post("/common/name-mapping/", {
                basics: this.basics,
                id_list: ids,
              })
              .then((mapping) => {
                if (mapping.data) {
                  const mappingArray = JSON.parse(mapping.data);
                  return {
                    tableDataResponse: tableDataResponse,
                    mappingArray: mappingArray,
                    tableType: this.quickReports,
                  };
                }
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getConsolidatedData(queryObject) {
      console.log(queryObject,'queryObject')
      this.isConsolidated = true;
      const objectWithoutKey = (object, key) => {
        const { [key]: deletedKey, ...otherKeys } = object;
        return otherKeys;
      };
      if (
        this.quickReports == "mtd" ||
        this.quickReports == "ytd" ||
        this.quickReports == "wtd" ||
        this.quickReports == "qtd" ||
        this.quickReports == "sale" ||
        this.quickReports == "wow" ||
        this.quickReports == "mom"
      ) {
        return serverAddr
          .post("sales/analytics/", objectWithoutKey(queryObject, "aggregate"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit("setAnalyticsData", {});
            this.$store.commit("setGraphData", {
              xAxisData: [],
              series: {
                seriesYaxis: [],
              },
            });
            // EventBus.$emit("callReRenderOneBarGraph", true);
            this.$store.commit("setGraphVisibility", new Date().getTime());
          });
      } else {
        return serverAddr
          .post("sales/query/", objectWithoutKey(queryObject, "quickreport"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            console.log(error);
            let graph = true;
            this.$store.commit("setAnalyticsData", {});
            this.$store.commit("setGraphData", {
              xAxisData: [],
              series: {
                seriesYaxis: [],
              },
            });
            // EventBus.$emit("callReRenderOneBarGraph", graph);
            this.$store.commit("setGraphVisibility", new Date().getTime());
          });
      }
    },

    combineData(analyticsQueryObject, consolidatedQueryObject, pageInfo) {
      this.$store.commit("setLoader", true); //enabled loader
      this.basics = this.basics;
      axios
        .all([
          this.AnalyticsData(analyticsQueryObject, pageInfo),
          this.getConsolidatedData(consolidatedQueryObject),
        ])
        .then(
          axios.spread((tableData, consolidatedTableData) => {
            EventBus.$emit("disableFirstButton", false);
            if (JSON.parse(tableData.tableDataResponse.data).results.length) {
              console.log("this", this.basics);
              // this.$store.commit('setGraphReRenderStatus', new Date().getTime());  //call rerender function in woowgraph componenent
              this.AnalyticsDataNC(
                tableData.tableDataResponse,
                tableData.tableType,
                tableData.mappingArray,
                consolidatedTableData
              );
            } else {
              // let graph = true;
              // clear set analytics data and graph data when server send empty results.
              this.$store.commit("setAnalyticsData", {});
              this.$store.commit("setGraphData", {
                xAxisData: [],
                series: {
                  seriesYaxis: [],
                },
              });

              console.log("else");
              // EventBus.$emit("callReRenderOneBarGraph", graph);
              this.$store.commit("setGraphVisibility", new Date().getTime());
            }

            this.$store.commit("setLoader", false); //disabled loader
            this.isButtonClicked = false;
            this.$store.commit("IS_OUTLET_CLIKED_FROM_TABLE", false);
          })
        )
        .catch((error) => {
          EventBus.$emit("disableFirstButton", false);
          this.$store.commit("setLoader", false); //disabled loader
          console.log(error);
        });
    },

    resetPageInfo() {
      EventBus.$emit("resetPageInfoEvent");
      // console.log("resseting page info");
      this.pageInfo.pageSize = 20;
      this.pageInfo.currentPage = 1;
    },

    yesterdayDate() {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
    },

    handlePageInfoChange(pageInfo) {
      // debugger;
      this.pageInfo.pageSize = pageInfo.pageSize;
      this.pageInfo.currentPage = pageInfo.currentPage;
      // console.log(this.basicsInfo, this.pageInfo);
      this.combineData(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    handleCurrentPageChange(currentPage) {
      this.pageInfo.currentPage = currentPage;
      this.combineData(
        this.queryObject(this.basicsInfo, false),
        this.queryObject(this.basicsInfo, true),
        this.pageInfo
      );
    },

    insertIsSelectedKey(arr) {
      arr.map((obj) => {
        obj.isSelected = false;
        Object.keys(obj).map((key) => {
          // console.log("is key value array", obj[key]);
          if (Array.isArray(obj[key])) {
            this.insertIsSelectedKey(obj[key]);
          }
        });
      });
      return arr;
    },

    getOptionsSelectedBySales() {
      var idNameMap = this.getIdNameMap(this.locations);
      var locations_name, categories_name;
      // ******************Location name mapping*****************************
      locations_name = this.filterLocIds.map((id) => {
        for (var i = 0; i < idNameMap.length; i++) {
          if (idNameMap[i].id == id) {
            return idNameMap[i].name;
          }
        }
      });
      // ******************Quick report & view, name mapping*****************************
      var selected_qr, selected_sv;
      for (var x in this.allQuickReports) {
        if (this.allQuickReports[x].id == this.quickReports) {
          selected_qr = this.allQuickReports[x].name;
        }
      }
      for (var x in this.allSalesView) {
        if (this.allSalesView[x].id == this.selectSalesView) {
          selected_sv = this.allSalesView[x].name;
        }
      }
      // ******************set object for download csv*****************************
      var selectedObjSaleByLocation = {
        Quick_Reports: selected_qr,
        Sales_View: selected_sv,
        Date_From: this.dateFrom,
        Date_To: this.dateTo,
        Locations: locations_name.toString(),
      };
      // console.log("selectedObjSaleByLocation", selectedObjSaleByLocation);
      // ******************set object with category for download csv*****************************
      if (this.$route.name == "Category") {
        if (this.filterCatIds.length > 0) {
          var idNameCatMap = [];
          this.categories.map((obj) => {
            idNameCatMap.push({
              name: obj.name,
              id: obj.id,
            });
          });
          categories_name = this.filterCatIds.map((id) => {
            for (var i = 0; i < idNameCatMap.length; i++) {
              if (idNameCatMap[i].id == id) {
                return idNameCatMap[i].name;
              }
            }
          });
          selectedObjSaleByLocation.Categories = categories_name.toString();
        }
      }
      return this.downloadCsv(
        this.$route.name,
        selectedObjSaleByLocation,
        this.getAnalyticsData
      );
    },
    getAllMondayFromYear(time) {
      var d = new Date(time),
        year = d.getYear(),
        mondays = [];
      if (d < new Date()) {
        d.setDate(1);
        // Get the first Monday in the month
        while (d.getDay() !== 1) {
          d.setDate(d.getDate() + 1);
        }

        // Get all the other Mondays in the month
        while (d.getYear() === year) {
          var pushDate = new Date(d.getTime());
          mondays.push(moment(pushDate).format("YYYY-MM-DD"));
          d.setDate(d.getDate() + 7);
        }
      }
      return mondays;
    },
    disabledDueDate(time) {
      if (this.newquickReports == "week") {
        var mondays = this.getAllMondayFromYear(time);
        return !mondays.includes(moment(time).format("YYYY-MM-DD"));
      } else if (this.newquickReports == "month") {
        var first_date = new Date(time),
          year = first_date.getYear(),
          mondays = [];
        first_date.setDate(1);
        var now = new Date();
        var next_month_firstDate = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          1
        );
        if (next_month_firstDate > first_date) {
          if (new Date(1).getDate() != time.getDate()) {
            return time.getTime();
          }
        } else {
          return time.getTime();
        }
      } else {
        return time.getTime() > Date.now() - 8.64e7;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./AppSalesTab.scss";
@import "./AppSalesTabM.scss";
@import "../../../assets/css/variable.scss";
</style>
<style>
.AppSalesTab {
  margin: 0.5rem 0;
  border-radius: 4px;
}
.AppSalesTab .el-select > .el-input {
  margin-right: 5px;
}
.AppSalesTab .el-menu.el-menu--horizontal {
  border-bottom-color: 1px solid #c8c8c8 !important;
}
.AppSalesTab .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 39px;
  line-height: 42px;
  border: 1px solid #c8c8c8;
  color: #909399;
  border-radius: 4px !important;
}
</style>
